import { useMutation, gql } from '@apollo/client';

const UPDATE_ORDER_STATUSES = gql`
  mutation UpdateManyOrder($data: OrderUpdateManyMutationInput!, $where: OrderWhereInput) {
    updateManyOrder(data: $data, where: $where) {
      count
    }
  }
`;

const UPDATE_ORDER_TRACKING = gql`
  mutation UpdateManyOrder($data: OrderUpdateManyMutationInput!, $where: OrderWhereInput) {
    updateManyOrder(data: $data, where: $where) {
      count
    }
  }
`;

export const useUpdateOrderStatuses = () => {
  const [updateStatuses] = useMutation(UPDATE_ORDER_STATUSES);
  const [updateTracking] = useMutation(UPDATE_ORDER_TRACKING);

  const updateOrderStatuses = async (
    orderNumber: string,
    shippingStatus: number | null,
    orderStatus: number | null,
    isCharged: boolean | null,
    order?: any
  ) => {
    try {
      const data: any = {};
      
      if (shippingStatus !== null) {
        data.shippingStatus = { set: shippingStatus };
      }
      
      if (orderStatus !== null) {
        data.status = { set: orderStatus };
      }

      if (isCharged !== null) {
        data.isCharged = { set: isCharged };
      }

      const where = {
        orderNumber: { equals: orderNumber }
      };

      const response = await updateStatuses({
        variables: {
          data,
          where
        }
      });

      return response.data.updateManyOrder.count;
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  const updateOrderTracking = async (
    orderNumber: string,
    trackingNumber: string
  ) => {
    try {
      const data = {
        trackingNumber: { set: trackingNumber }
      };

      const where = {
        orderNumber: { equals: orderNumber }
      };

      const response = await updateTracking({
        variables: {
          data,
          where
        }
      });

      return response.data.updateManyOrder.count;
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  const updateOrderIsCharged = async (
    orderNumber: string,
    isCharged: boolean
  ) => {
    try {
      const data = {
        isCharged: { set: isCharged }
      };

      const where = {
        orderNumber: { equals: orderNumber }
      };

      const response = await updateStatuses({
        variables: {
          data,
          where
        }
      });

      return response.data.updateManyOrder.count;
    } catch (error: any) {
      throw new Error(error.message);
    }
  };

  return { 
    updateStatuses: updateOrderStatuses,
    updateTracking: updateOrderTracking,
    updateIsCharged: updateOrderIsCharged
  };
}; 